/**
 * Persists orchestration `sessionId` from WebSocket `connected` (and optional HTTP responses)
 * so follow-up turns can align with server-owned draft keys when the API supports it.
 */
export const ORCHESTRATION_SESSION_ID_KEY = "ai_prescription_orchestration_session_id";

export function getStoredOrchestrationSessionId(): string | undefined {
  if (typeof localStorage === "undefined") return undefined;
  const v = localStorage.getItem(ORCHESTRATION_SESSION_ID_KEY);
  return v?.trim() || undefined;
}

export function setStoredOrchestrationSessionId(id: string | null | undefined): void {
  if (typeof localStorage === "undefined") return;
  if (id && String(id).trim()) {
    localStorage.setItem(ORCHESTRATION_SESSION_ID_KEY, String(id).trim());
  } else {
    localStorage.removeItem(ORCHESTRATION_SESSION_ID_KEY);
  }
}
